import {
  DisableFocusWrapper,
  Link,
  LinkProps,
  Richtext,
  Text,
  TextAppearance,
  TextColor,
  createTagOverride,
} from '@vw-marketing/us-components';
import React from 'react';
import { useTrackingManager } from '../../services/use-tracking-manager';
import { ParagraphContainer, RichtextWrapper } from './styled';

interface ParagraphSectionProps {
  readonly head?: string;
  readonly richtext?: string;
  readonly textColor?: string;
  readonly linkColor?: string;
  readonly marginBottom?: string;
  readonly selfTarget?: boolean;
}

export const ParagraphSection: React.FC<ParagraphSectionProps> = (props) => {
  const { head, richtext, textColor, linkColor, marginBottom, selfTarget } =
    props;

  const trackingManager = useTrackingManager();

  const onClickLink = (e: any) => {
    const elem = e.target;
    const domain = window.location.hostname;
    const href = elem.getAttribute('href');
    const target = elem.getAttribute('target');
    const value = elem.text;

    trackingManager.trackEmissionsGlobalEvent(
      'VWBasic_Link_Click',
      {
        url: `${domain}${href}`,
        name: value,
        newTab: target === '_blank' ? true : false,
      },
      undefined,
    );
  };

  const tagOverrides = {
    span: createTagOverride(Text, {
      appearance: TextAppearance.copy200,
      color: TextColor.inherit,
    }),
    a: createTagOverride(Link, {
      isInline: false,
      target: selfTarget ? '_self' : '_blank',
      onClick: onClickLink,
    } as LinkProps),
  };

  return (
    <ParagraphContainer marginBottom={marginBottom}>
      {head && (
        <Text bold appearance={TextAppearance.copy200}>
          {head}
        </Text>
      )}

      {richtext && (
        <RichtextWrapper textColor={textColor} linkColor={linkColor}>
          <DisableFocusWrapper>
            <Richtext
              markdown={richtext}
              overrides={tagOverrides}
              dangerouslyParseRawHTML
            />
          </DisableFocusWrapper>
        </RichtextWrapper>
      )}
    </ParagraphContainer>
  );
};
